import { Directive } from 'angular-ts-decorators';

import { filter, takeUntil } from 'rxjs/operators';

import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';

/**
 * A directive that triggers a element focus when the stream emits.
 * The emit can be filtered by using a focus-when attribute which accepts a expression
 * The stream is provided by the given value of sw-set-focus="stream"
 *
 * # Attributes
 * sw-set-focus - stream
 * focus-when - only focus when stream emits a value that is equal to focus-when
 *
 * if the focus-when attribute is missing we always focus whenever the stream emits
 *
 * # Examples
 * <pre>
 *   <a sw-set-focus="$ctrl.stream">test</a>
 * </pre>
 * Focuses the element whenever the stream emits

 * <pre>
 *   <a sw-set-focus="$ctrl.stream" focus-when="'test'">test</a>
 * </pre>
 * Focuses the element only when the stream emits a value with test
 *
 * <pre>
 *   <a sw-set-focus>test</a>
 * </pre>
 * Focuses the element when it appears
 */
@Directive({
  selector: '[sw-set-focus]',
})
export class SwSetFocusDirective {
  constructor(
    private $parse,
    private $scope,
    private $attrs: ng.IAttributes,
    private $element: ng.IAugmentedJQuery,
    private $timeout: ng.ITimeoutService,
    private scopeStreams: ScopeStreams,
  ) {
    'ngInject';

    // TODO move to a parent class V6CompatibleDirective
    if (angular.version.minor <= 7) {
      this.$timeout(() => {
        this.ngAfterViewInit();
      });
    }
  }

  ngAfterViewInit() {
    const setFocusValue = this.$attrs.swSetFocus,
      setFocus$ = this.$parse(setFocusValue)(this.$scope),
      focusWhen = this.$parse(this.$attrs.focusWhen)(this.$scope),
      destroy$ = this.scopeStreams.isDestroyed(this.$scope);

    if (setFocus$ && angular.isFunction(setFocus$.pipe)) {
      setFocus$
        .pipe(
          filter((value) => {
            if ('focusWhen' in this.$attrs) {
              return value === focusWhen;
            }
            return true;
          }),
          takeUntil(destroy$),
        )
        .subscribe(() => {
          this.$element[0].focus();
        });
    } else if (!setFocusValue) {
      this.$element[0].focus();
    }
  }
}
